import { ICustomFile } from '@pu/mpp-ui/components/form';
import { IUploadFilesResponseDTO } from './upload-files.dto';

export const mapFilesToFormData = (files: Array<ICustomFile>) => {
  const formData = new FormData();

  files.forEach(file => {
    formData.append('images', file.blob as File);
  });

  return formData;
};

export const mapFilesToFormDataResponse = (files: IUploadFilesResponseDTO): IUploadFilesResponseDTO => ({
  imageUrls: files.imageUrls.map(file => encodeURI(file)),
});
